import { h } from 'preact'
import { IdeaStatus } from '@insided/control/modules/ContentModeration/TopicModeration/interfaces'

const IdeationStatus = ({ ideationStatus }: { ideationStatus: IdeaStatus }) => (
  <span
    style={`color:${ideationStatus.textColor};background-color:${ideationStatus.backgroundColor};`}
    className='idea-status-pill'
  >
    {ideationStatus.name}
  </span>
)

export default IdeationStatus
